import styled from "styled-components";
import { _ } from "@sablier/v2-mixins";
import { usePollingAwareness } from "~/client/hooks";
import Confirmation from "../Confirmation";
import Summary from "../Summary";
import { useInit } from "../logic";

const WrapperPartial = styled.div`
  ${(props) => props.theme.styles.column}
  & {
    row-gap: calc(${(props) => props.theme.sizes.edge} * 3 / 2);
    width: 100%;
    padding: calc(${(props) => props.theme.sizes.edge} * 3 / 2);
    padding-right: calc(${(props) => props.theme.sizes.edge} * 2);
    padding-left: calc(${(props) => props.theme.sizes.edge} * 2);
  }
`;

const Divider = styled.div`
  width: 100%;
  height: 2px;
  background-color: ${(props) => props.theme.colors.border};
`;

const Wrapper = styled(WrapperPartial)`
  ${(props) => props.theme.medias.maxMD} {
    padding-right: calc(${(props) => props.theme.sizes.edge} * 3 / 2);
    padding-left: calc(${(props) => props.theme.sizes.edge} * 3 / 2);
  }
  ${(props) => props.theme.medias.maxSM} {
    row-gap: calc(${(props) => props.theme.sizes.edge} * 3 / 4);
    padding: calc(${(props) => props.theme.sizes.edge} * 3 / 4);
    padding-right: calc(${(props) => props.theme.sizes.edge} * 3 / 4);
    padding-left: calc(${(props) => props.theme.sizes.edge} * 3 / 4);
  }
`;

function Body() {
  useInit();
  usePollingAwareness({ condition: true, page: "dashboard" });

  return (
    <Wrapper>
      <Summary />
      <Divider />
      <Confirmation />
    </Wrapper>
  );
}

export default Body;
